import React from "react";
import "./Terms_of_Services.css";
import "../../Homepage/LegalPageTheme.css";
import HeroNav from "../../Homepage/HeroNav";
import LegalLinks from "../../Homepage/LegalLinks";

const Terms_of_Services = ({ onClose }) => {
  return (
    <div className="TOS_Page">
      <HeroNav compact />

      {/* Page Content */}
      <div className="TOS_Body">
        <h1 className="TOS_Title">USER AGREEMENT / TERMS OF USE</h1>
        <h2 className="TOS_Title1">FOR Bolo-India Media (App name)</h2>
        <br />
        <h3 className="TOS_Updated">Effective Date: 06-August-2026</h3>
        <h3 className="TOS_Updated">Last Updated: 06-August-2026</h3>
        <br />
        <p>
          This User Agreement (“Agreement” or “Terms”) governs your access to
          and use of <strong>Bolo-India Media,</strong> including its mobile
          applications, website, APIs, features, software, services and
          associated platforms (collectively, the “Platform”).
        </p>
        <p>
          The Platform is owned and operated by{" "}
          <strong>Bolo-India Media Networks Private Limited,</strong> a company
          incorporated under the laws of India and having its registered office
          at{" "}
          <strong>
            122, Narasimha, C-Wing, 3rd main, Gruhalakshmi Layout 2nd Stage,
            Kamalanagar, Bangalore 560079, Karnataka, India (“Company”, “we”,
            “us” or “our”).
          </strong>
        </p>
        <p>
          By creating an account, accessing or using the Platform, you confirm
          that you have read, understood and agreed to these Terms, together
          with our Privacy Policy, Community Guidelines, Copyright Policy and
          other policies incorporated by reference.
        </p>
        <p>
          If you do not agree with these Terms, you must not access or use the
          Platform.
        </p>

        <h2>1. ELIGIBILITY AND ACCOUNT REGISTRATION</h2>
        <h2>A. Eligibility</h2>
        <p>
          You may use the Platform only if you are legally capable of entering
          into a binding agreement under applicable Indian law and satisfy any
          minimum-age or parental/guardian-consent requirements applicable to
          the Platform.
        </p>
        <p>
          Where the processing of personal data relates to a child, the Company
          will implement measures required under the{" "}
          <strong>
            Digital Personal Data Protection Act, 2023 (“DPDP Act”),
          </strong>{" "}
          the rules made thereunder and other applicable law.
        </p>

        <h2>B. Account Registration</h2>
        <p>
          To access certain features, you may be required to create an account
          using information such as your:
        </p>
        <ul>
          <li>name;</li>
          <li>mobile number;</li>
          <li>email address;</li>
          <li>username;</li>
          <li>date or year of birth, where required;</li>
          <li>profile photograph;</li>
          <li>language;</li>
          <li>location information where enabled;</li>
          <li>authentication credentials; and</li>
          <li>other information required for providing the Platform.</li>
        </ul>
        <p>
          You agree that information supplied by you will be accurate and not
          intentionally misleading.
        </p>

        <h2>C. Account Security</h2>
        <p>
          You are responsible for maintaining the confidentiality of your
          password, OTP, authentication credentials and devices used to access
          your account.
        </p>
        <p>
          You must promptly notify the Company if you reasonably believe that
          your account has been compromised or accessed without authorisation.
        </p>

        <h2>2. NATURE OF THE PLATFORM</h2>
        <p>
          Bolo-India Media is a social-media and digital communication platform
          that may enable users to:
        </p>
        <ul>
          <li>create profiles;</li>
          <li>publish text, photographs and graphics;</li>
          <li>upload videos and short-form videos;</li>
          <li>upload or use audio and music where authorised;</li>
          <li>comment and react;</li>
          <li>follow users;</li>
          <li>share or repost content;</li>
          <li>participate in communities;</li>
          <li>send messages;</li>
          <li>livestream;</li>
          <li>discover content;</li>
          <li>interact with creators, businesses and organisations;</li>
          <li>view advertisements and sponsored content; and</li>
          <li>access other features introduced from time to time.</li>
        </ul>
        <p>
          The Company may modify, discontinue, test or introduce Platform
          features subject to applicable law.
        </p>

        <h2>3. USER-GENERATED CONTENT</h2>
        <p>
          “User Content” means content uploaded, created, transmitted, streamed,
          published, displayed or otherwise made available by a user through the
          Platform, including text, photographs, graphics, music, audio, videos,
          audiovisual works, livestreams, comments, messages and other material.
        </p>
        <p>
          You retain ownership of intellectual-property rights that you legally
          own in your User Content.
        </p>
        <p>
          Uploading content to Bolo-India Media does not transfer ownership of
          your copyright to the Company except to the extent expressly agreed
          separately.
        </p>

        <h2>4. LICENCE TO Bolo-India Media</h2>
        <p>
          When you upload or publish User Content, you grant the Company a
          non-exclusive, worldwide, royalty-free, transferable and sublicensable
          licence, for the period permitted under applicable law and subject to
          your privacy/settings choices, to host, store, reproduce, process,
          format, adapt for technical purposes, distribute, transmit, display,
          communicate and otherwise use such User Content as reasonably
          necessary to:
        </p>
        <ul>
          <li>operate the Platform;</li>
          <li>display your content to the audiences selected by you;</li>
          <li>distribute content through Platform features;</li>
          <li>enable sharing, reposting, recommendations and discovery;</li>
          <li>
            optimise content for different devices and network conditions;
          </li>
          <li>
            create thumbnails, previews, captions and technical derivatives;
          </li>
          <li>secure and moderate the Platform; and</li>
          <li>
            promote the Platform, where separately permitted by applicable
            settings, permissions or law.
          </li>
        </ul>
        <p>
          This licence does not give the Company ownership of your User Content.
        </p>
        <p>
          Where content is deleted, copies may remain temporarily in backups,
          caches, legalpreservation systems or where another user has
          independently shared or incorporated the content, subject to
          applicable law.
        </p>

        <h2>5. USER REPRESENTATIONS REGARDING CONTENT</h2>
        <p>By uploading User Content, you represent that:</p>
        <ul>
          <li>you created the content; or</li>
          <li>you own the necessary rights; or</li>
          <li>
            you have obtained necessary licences, permissions and consents; or
          </li>
          <li>your use is otherwise permitted under applicable law.</li>
        </ul>
        <p>
          You must not upload content that infringes another person's copyright,
          trademark, privacy, publicity, contractual or other legal rights.
        </p>

        <h2>6. MUSIC, AUDIO AND COPYRIGHT</h2>
        <p>
          Music is protected by copyright law in India. Rights may exist
          separately in musical compositions, lyrics, sound recordings and
          performances.
        </p>
        <p>
          Accordingly, owning a copy of a song, purchasing a subscription to a
          music-streaming service, or downloading a song does{" "}
          <strong>
            not necessarily give you the right to incorporate that song into a
            video or communicate it to the public through Bolo-India Media.
          </strong>
        </p>

        <h2>6.1 Platform-Licensed Music</h2>
        <p>
          Where Bolo-India Media provides an authorised music library,
          catalogue, audio clip or music-selection feature, users may use such
          music only:
        </p>
        <ul>
          <li>through the functionality provided;</li>
          <li>within the territories covered by the relevant licences;</li>
          <li>for the permitted duration and type of content;</li>
          <li>
            for permitted personal or commercial purposes, as applicable; and
          </li>
          <li>
            subject to restrictions imposed by music labels, publishers,
            copyright societies, artists or other rightsholders.
          </li>
        </ul>
        <p>
          Availability of music may differ according to territory, account type
          and intended use.
        </p>

        <h2>6.2 User-Uploaded Music</h2>
        <p>
          Where you independently upload music or incorporate music into a
          video, you are responsible for obtaining all necessary rights,
          permissions and licences.
        </p>
        <p>
          Depending on the content and intended use, rights may include rights
          relating to:
        </p>
        <ul>
          <li>musical compositions;</li>
          <li>lyrics;</li>
          <li>sound recordings/master recordings;</li>
          <li>performers;</li>
          <li>synchronisation of music with video;</li>
          <li>reproduction;</li>
          <li>communication to the public; and</li>
          <li>other applicable exploitation rights.</li>
        </ul>

        <h2>6.3 Commercial Content</h2>
        <p>
          Music available for personal user-generated content may not
          necessarily be cleared for advertisements, branded content, paid
          promotions, business accounts or other commercial uses.
        </p>
        <p>
          Businesses, advertisers and creators using content commercially are
          responsible for ensuring that their music usage is properly licensed
          for that purpose.
        </p>

        <h2>6.4 Music Removal</h2>
        <p>
          The Company may mute, block, restrict, demonetise or remove audio or
          content where:
        </p>
        <ul>
          <li>a copyright owner submits a valid complaint;</li>
          <li>applicable licences expire or change;</li>
          <li>territorial rights are unavailable;</li>
          <li>
            automated systems identify potentially unauthorised content; or
          </li>
          <li>applicable law requires removal.</li>
        </ul>

        <h2>7. VIDEO AND FILM COPYRIGHT</h2>
        <p>
          Users must not upload unauthorised copies or substantial protected
          portions of:
        </p>
        <ul>
          <li>films;</li>
          <li>television programmes;</li>
          <li>OTT content;</li>
          <li>sports broadcasts;</li>
          <li>music videos;</li>
          <li>web series;</li>
          <li>documentaries;</li>
          <li>concerts;</li>
          <li>copyrighted livestreams; or</li>
          <li>other protected audiovisual works.</li>
        </ul>
        <p>
          The Copyright Act, 1957 recognises separate protection for
          cinematograph films and sound recordings, among other protected works.
        </p>
        <p>
          A user claiming that use of copyrighted material is permitted under an
          exception—including fair dealing—remains responsible for ensuring that
          the legal requirements of the relevant exception are satisfied.
        </p>

        <h2>8. COPYRIGHT COMPLAINT AND TAKEDOWN PROCEDURE</h2>
        <p>
          Copyright owners or authorised representatives may report allegedly
          infringing material to:
        </p>
        <p>
          Copyright/Grievance Officer <br />
          Name: <br />
          Email: grievances@bolindia.com <br />
          Address: 122, Narasimha, 3rd main, Gruhalakshmi layout 2nd stage,
          Kamalanagar, Bangalore 560079, Karnataka, India.
        </p>
        <strong>A complaint should identify:</strong>
        <ul>
          <li>1. the copyrighted work;</li>
          <li>2. the allegedly infringing content;</li>
          <li>3. the URL, post ID or other identifying information;</li>
          <li>4. the complainant&apos;s contact details;</li>
          <li>
            5. evidence or a statement concerning ownership/authority; and
          </li>
          <li>
            6. other information reasonably required under applicable law.
          </li>
        </ul>
        <p>
          The Company may remove or disable access to content where legally
          required or where it reasonably determines that the content violates
          this Agreement.
        </p>
        <p>
          The Company may provide an appropriate opportunity for the affected
          user to dispute a copyright claim where applicable.
        </p>
        <p>
          Repeated infringement may result in warnings, feature restrictions,
          suspension or termination.
        </p>

        <h2>9. PROHIBITED CONTENT AND CONDUCT</h2>
        <p>
          Users must not use the Platform to publish, transmit or facilitate
          content or conduct prohibited by applicable law or the Platform&apos;s
          policies, including content involving:
        </p>
        <ul>
          <li>unlawful activity;</li>
          <li>impersonation;</li>
          <li>infringement of intellectual-property rights;</li>
          <li>malicious software;</li>
          <li>fraudulent or deceptive activity;</li>
          <li>unlawful threats or harassment;</li>
          <li>unlawful invasion of privacy;</li>
          <li>child sexual abuse material;</li>
          <li>non-consensual intimate imagery;</li>
          <li>content prohibited under applicable Indian law; or</li>
          <li>
            attempts to interfere with the Platform&apos;s security or
            operation.
          </li>
        </ul>
        <p>
          The Platform may maintain separate Community Guidelines explaining
          content and behavioural standards in greater detail.
        </p>

        <h2>10. INTERMEDIARY COMPLIANCE</h2>
        <p>
          To the extent that Bolo-India Media qualifies as an “intermediary”,
          “social media intermediary” or “significant social media
          intermediary”, the Company will implement applicable obligations under
          the{" "}
          <strong>
            Information Technology Act, 2000 and the Information Technology
            (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021,
          </strong>
          as amended from time to time.
        </p>
        <p>
          These may include applicable requirements concerning due diligence,
          publication of policies, grievance redressal, compliance personnel,
          reporting, removal or disabling of access to unlawful content and
          cooperation with lawful government or judicial orders.
        </p>

        <h2>11. CONTENT MODERATION</h2>
        <p>
          The Company may use human review, automated systems, artificial
          intelligence, user reports and other mechanisms to identify content
          potentially violating these Terms, Community Guidelines or applicable
          law.
        </p>
        <p>Depending on the circumstances, the Company may:</p>
        <ul>
          <li>reduce distribution;</li>
          <li>apply warnings;</li>
          <li>age-restrict content;</li>
          <li>disable comments or other features;</li>
          <li>remove audio;</li>
          <li>remove content;</li>
          <li>suspend monetisation;</li>
          <li>restrict an account;</li>
          <li>temporarily suspend an account; or</li>
          <li>terminate an account.</li>
        </ul>
        <p>
          Where required by applicable law or Platform policy, users may be
          provided appropriate reasons or appeal mechanisms.
        </p>

        <h2>12. PRIVACY AND PERSONAL DATA</h2>
        <p>
          The Company processes personal data in accordance with applicable
          Indian data-protection law, including the{" "}
          <strong>Digital Personal Data Protection Act, 2023</strong> and
          applicable rules made thereunder, including the{" "}
          <strong>Digital Personal Data Protection Rules, 2025,</strong>{" "}
          according to their applicable commencement provisions.
        </p>
        <p>
          A detailed description of the Company&apos;s processing activities
          will be contained in the <strong>Privacy Policy,</strong> which forms
          part of the Platform&apos;s legal framework.
        </p>

        <h2>13. DATA WE MAY COLLECT</h2>
        <p>
          Depending upon how you use Bolo-India Media, the Company may process
          categories of data including:
        </p>
        <ul>
          <li>
            <strong>Account Data</strong>
            <br />
            Name, username, telephone number, email address, age/date-of-birth
            information and profile information.
          </li>
          <li>
            <strong>User Content</strong>
            <br />
            Posts, photographs, videos, audio, comments, reactions and other
            information submitted through the Platform.
          </li>
          <li>
            <strong>Device and Technical Data</strong>
            <br />
            Device model, operating system, browser information, app version, IP
            address, device identifiers and diagnostic information.
          </li>
          <li>
            <strong>Usage Data</strong>
            <br />
            Content viewed, interactions, searches, follows, shares, engagement,
            session information and Platform activity.
          </li>
          <li>
            <strong>Location Data</strong>
            <br />
            Approximate location derived from technical information and, where
            specifically enabled and permitted, more precise location
            information.
          </li>
          <li>
            <strong>Communication Data</strong>
            <br />
            Information supplied when communicating with customer support,
            grievance officers or the Company.
          </li>
          <li>
            <strong>Advertising Data</strong>
            <br />
            Advertising interactions, campaign measurements and related
            information where applicable.
          </li>
        </ul>

        <h2>14. PURPOSES OF DATA PROCESSING</h2>
        <p>Personal data may be processed for lawful purposes such as:</p>
        <ul>
          <li>creating and maintaining accounts;</li>
          <li>providing Platform functionality;</li>
          <li>authenticating users;</li>
          <li>personalising user experiences;</li>
          <li>recommending content;</li>
          <li>operating feeds and search;</li>
          <li>preventing spam, fraud and abuse;</li>
          <li>maintaining security;</li>
          <li>enforcing Platform policies;</li>
          <li>responding to complaints;</li>
          <li>complying with legal obligations;</li>
          <li>analytics and Platform improvement;</li>
          <li>communications requested or permitted by users;</li>
          <li>advertising and measurement where legally permissible; and</li>
          <li>other purposes disclosed through appropriate notices.</li>
        </ul>

        <h2>15. NOTICE AND CONSENT UNDER THE DPDP FRAMEWORK</h2>
        <p>
          Where processing is based on consent, the Company will seek consent in
          accordance with applicable provisions of the DPDP Act and rules.
        </p>
        <p>
          Consent must relate to the specified purpose and meet applicable
          requirements concerning free, specific, informed, unconditional and
          unambiguous consent through clear affirmative action.
        </p>
        <p>
          Users will be provided appropriate notice describing, among other
          things, the personal data and purpose of processing and mechanisms for
          exercising applicable rights.
        </p>
        <p>
          Where consent is the basis for processing, users may withdraw consent
          in accordance with applicable law.
        </p>
        <p>
          Withdrawal of consent will not invalidate processing lawfully carried
          out before such withdrawal.
        </p>
        <p>
          Some Platform functionality may become unavailable where the relevant
          personal data is necessary to provide that functionality.
        </p>

        <h2>16. RIGHTS OF DATA PRINCIPALS</h2>
        <p>
          Subject to the DPDP Act, applicable rules, commencement provisions and
          lawful exemptions, users may have rights including:
        </p>
        <ul>
          <li>access to information about personal-data processing;</li>
          <li>correction of inaccurate or misleading personal data;</li>
          <li>completion or updating of personal data;</li>
          <li>erasure of personal data where applicable;</li>
          <li>grievance redressal; and</li>
          <li>
            nomination of another individual to exercise applicable rights in
            circumstances specified by law.
          </li>
        </ul>
        <p>Requests may be submitted through:</p>
        <strong>Privacy Contact:</strong>
        <p>
          <strong>Email: </strong>grievances@boloindia.com <br />
          <strong>In-App Privacy Centre: </strong>Settings &rarr; Privacy and
          Security &rarr;
        </p>
        <p>The Company may authenticate requests before acting on them.</p>

        <h2>17. USER OBLIGATIONS UNDER DATA PROTECTION LAW</h2>
        <p>
          Users must not impersonate another individual while providing personal
          data;
        </p>
        <p>
          Users should not suppress material information while providing
          personal data for documents, identifiers or services;
        </p>
        <p>
          {" "}
          Users must not submit false, frivolous or misleading grievances or
          complaints; and
        </p>
        <p>
          Users must provide authentic and accurate information when exercising
          statutory rights, where required by law.
        </p>

        <h2>18. CHILDREN'S PERSONAL DATA</h2>
        <p>
          Where applicable under the DPDP Act and rules, the Company will obtain
          verifiable consent of a parent or lawful guardian before processing a
          child's personal data unless an applicable exemption applies.
        </p>
        <p>
          The Platform will implement appropriate measures concerning processing
          involving children as required by applicable law.
        </p>
        <p>
          Where legally applicable, the Platform will not undertake prohibited
          tracking, behavioural monitoring or targeted advertising directed at
          children.
        </p>
        <p>
          Age-assurance and parental-consent mechanisms may be introduced or
          modified to comply with applicable law.
        </p>

        <h2>19. DATA SECURITY</h2>
        <p>
          The Company will implement reasonable technical and organisational
          safeguards to protect personal data under its control;
        </p>
        <p>Measures may include encryption of data;</p>
        <ul>
          <li>encryption;</li>
          <li>access controls;</li>
          <li>authentication mechanisms;</li>
          <li>logging;</li>
          <li>network security;</li>
          <li>security monitoring;</li>
          <li>vulnerability management;</li>
          <li>backup and recovery controls;</li>
          <li>employee access restrictions;</li>
          <li>incident-response procedures; and</li>
          <li>contractual safeguards for service providers.</li>
        </ul>
        <p>No internet-based service can guarantee absolute security.</p>
        <p>
          Users should use strong authentication credentials and must not share
          OTPs or passwords with anyone.
        </p>

        <h2>20. PERSONAL DATA BREACH</h2>
        <p>
          Where a personal-data breach occurs, the Company will take appropriate
          steps to contain, investigate and remediate the incident.
        </p>
        <p>
          Notifications to affected Data Principals and the{" "}
          <strong>Data Protection Board of India</strong> will be made where and
          in the manner required under applicable DPDP provisions and rules.
        </p>

        <h2>21. DATA RETENTION</h2>
        <p>
          The Company will retain personal data only for as long as reasonably
          necessary for the purposes for which it was collected, or as required
          or permitted under applicable law.
        </p>
        <p>
          Data may be retained for longer periods where reasonably necessary
          for:
        </p>
        <ul>
          <li>legal compliance;</li>
          <li>dispute resolution;</li>
          <li>fraud prevention;</li>
          <li>security;</li>
          <li>enforcement;</li>
          <li>court proceedings;</li>
          <li>regulatory requirements; or</li>
          <li>exercise or defence of legal claims.</li>
        </ul>
        <p>
          Thereafter, personal data will be erased or anonymised where required
          and reasonably practicable.
        </p>

        <h2>22. DATA PROCESSORS AND SERVICE PROVIDERS</h2>
        <p>
          The Company may engage third parties to perform services including:
        </p>
        <ul>
          <li>cloud hosting;</li>
          <li>content delivery;</li>
          <li>analytics;</li>
          <li>customer support;</li>
          <li>security;</li>
          <li>fraud detection;</li>
          <li>communications;</li>
          <li>payment processing;</li>
          <li>advertising technology; and</li>
          <li>content moderation.</li>
        </ul>
        <p>
          Such entities may process personal data on behalf of the Company,
          subject to applicable contractual and legal requirements.
        </p>

        <h2>23. CROSS-BORDER DATA PROCESSING</h2>
        <p>
          The Platform may use infrastructure, vendors or service providers
          located outside India.
        </p>
        <p>
          Personal data may therefore be transferred or processed outside India
          to the extent permitted under the DPDP Act, applicable rules and
          restrictions notified by the Central Government.
        </p>
        <p>
          Where sector-specific data localisation requirements apply, the
          Company will comply with such requirements.
        </p>

        <h2>24. COOKIES AND TRACKING TECHNOLOGIES</h2>
        <p>
          The Platform may use cookies, SDKs, pixels, local storage, device
          identifiers and similar technologies for purposes including
          authentication, security, user preferences, analytics, advertising and
          performance.
        </p>
        <p>
          Where consent or user choice is required, appropriate controls and
          options will be provided in accordance with applicable law.
        </p>

        <h2>25. ADVERTISING</h2>
        <p>
          Bolo-India Media may display advertisements, promoted posts, sponsored
          content and branded content.
        </p>
        <p>
          Advertising may be contextual or personalised, where permitted under
          applicable law and based on user settings.
        </p>
        <p>
          Advertisers are responsible for ensuring that their advertisements
          comply with applicable laws, intellectual-property rights and
          advertising standards.
        </p>
        <p>
          Sponsored or promotional content may be labelled as required under
          applicable law and Platform policies.
        </p>

        <h2>26. CREATOR AND COMMERCIAL CONTENT</h2>
        <p>
          Creators participating in monetisation, sponsorship or commercial
          programmes must comply with:
        </p>
        <ul>
          <li>applicable advertising laws and standards;</li>
          <li>disclosure requirements;</li>
          <li>intellectual-property laws;</li>
          <li>tax obligations;</li>
          <li>consumer-protection requirements; and</li>
          <li>
            additional Creator or Monetisation Terms issued by the Company.
          </li>
        </ul>
        <p>
          Paid promotions, endorsements and sponsored content must be clearly
          disclosed where required.
        </p>

        <h2>27. ARTIFICIAL INTELLIGENCE AND SYNTHETIC CONTENT</h2>
        <p>
          The Platform may use artificial intelligence for recommendations,
          moderation, translation, captioning, safety, search, content discovery
          and other functionalities.
        </p>
        <p>
          Where users create or upload AI-generated, manipulated or synthetic
          content, they must comply with applicable Platform labelling
          requirements and Indian law.
        </p>
        <p>
          The Company may apply labels, metadata, disclosures or technical
          measures to identify synthetically generated or materially altered
          content, where required by applicable law or Platform policies.
        </p>

        <h2>28. USER MESSAGES AND COMMUNICATIONS</h2>
        <p>
          The Platform may enable private or direct communications between
          users.
        </p>
        <p>
          Users must not use messaging features for spam, fraud, unlawful
          solicitation, harassment, distribution of illegal content or other
          prohibited purposes.
        </p>
        <p>
          The Company may process message-related metadata and, where permitted
          or required by applicable law, message content for purposes including
          security, abuse prevention, user reporting and legal compliance.
        </p>

        <h2>29. LAW-ENFORCEMENT REQUESTS</h2>
        <p>
          The Company may preserve, disclose or provide information where
          required under applicable law, lawful court orders, authorised
          governmental requests or other legally binding processes.
        </p>
        <p>
          The Company may challenge requests it reasonably believes are invalid
          or legally deficient, where permitted by law.
        </p>

        <h2>30. GRIEVANCE REDRESSAL</h2>
        <p>Users may submit complaints regarding:</p>
        <ul>
          <li>account issues;</li>
          <li>privacy;</li>
          <li>personal data;</li>
          <li>Platform content;</li>
          <li>copyright;</li>
          <li>impersonation;</li>
          <li>harassment;</li>
          <li>Platform-policy violations; or</li>
          <li>other legally recognised grievances.</li>
        </ul>

        <p>
          <strong>Grievance Officer</strong>
          <br />
          Name:
          <br />
          Designation: Grievance Redressal Officer (GRO)
          <br />
          Email:{" "}
          <a href="mailto:grievances@boloindia.com">grievances@boloindia.com</a>
          <br />
          Postal Address: 122, Narasimha, C-wing, 3rd main, Gruhalakshmi Layout
          II Stage, Kamalanagar, Bangalore 560079, Karnataka, India.
        </p>

        <p>
          Complaints will be acknowledged, handled and resolved within timelines
          prescribed under applicable Indian law.
        </p>
        <p>
          Where the Company qualifies as a Significant Social Media
          Intermediary, additional officers, contact details and compliance
          mechanisms will be published as required under applicable law.
        </p>

        <h2>31. ACCOUNT SUSPENSION AND TERMINATION</h2>
        <p>
          The Company may restrict, suspend or terminate user accounts where
          reasonably necessary due to:
        </p>
        <ul>
          <li>material or repeated violations of these Terms;</li>
          <li>serious violations of Community Guidelines;</li>
          <li>copyright infringement;</li>
          <li>fraudulent activity;</li>
          <li>security threats;</li>
          <li>impersonation;</li>
          <li>legal or regulatory requirements; or</li>
          <li>conduct that creates material risk to users or the Platform.</li>
        </ul>
        <p>
          Where required, appropriate notice and appeal mechanisms will be
          provided.
        </p>
        <p>
          Users may terminate their accounts through the Platform’s
          account-deletion mechanism.
        </p>

        <h2>32. ACCOUNT DELETION</h2>
        <p>Users may request deletion of their account through:</p>
        <p>
          <strong>Settings → Account → Delete Account</strong>
          <br />
          or any other mechanism notified by the Company.
        </p>
        <p>
          Deletion may result in permanent loss of posts, followers, messages,
          saved content and other account-related information.
        </p>
        <p>
          Certain information may continue to be retained where required or
          permitted under applicable law, including for security, fraud
          prevention, regulatory compliance, dispute resolution and legal
          claims.
        </p>

        <h2>33. INTELLECTUAL PROPERTY OF THE PLATFORM</h2>
        <p>
          Except for User Content and third-party materials, the Platform and
          its software, interfaces, designs, logos, trademarks, databases,
          graphics and proprietary technology are owned by or licensed to the
          Company.
        </p>
        <p>
          Nothing in these Terms grants users any ownership rights in the
          Company’s intellectual property.
        </p>
        <p>
          Users may not copy, reverse engineer, sell, sublicense or commercially
          exploit the Platform except where expressly permitted by the Company
          or applicable law.
        </p>

        <h2>34. THIRD-PARTY SERVICES</h2>
        <p>
          The Platform may contain links to third-party websites, apps, payment
          services or other services.
        </p>
        <p>
          The Company is not responsible for independent third-party services,
          privacy practices or content merely because they are accessible
          through the Platform.
        </p>

        <h2>35. DISCLAIMER</h2>
        <p>
          The Platform is provided on an “as available” basis subject to
          applicable law.
        </p>
        <p>
          The Company does not guarantee uninterrupted availability or that
          every item of User Content will be accurate, reliable or appropriate.
        </p>
        <p>
          Opinions expressed by users belong to those users and do not
          necessarily represent the Company.
        </p>
        <p>
          Nothing in this Agreement excludes warranties or liabilities that
          cannot lawfully be excluded.
        </p>

        <h2>36. LIMITATION OF LIABILITY</h2>
        <p>
          To the maximum extent permitted by applicable law, the Company will
          not be liable for indirect, incidental, consequential, special or
          punitive losses arising from use of the Platform, except where
          liability cannot legally be excluded or limited.
        </p>
        <p>
          Nothing in these Terms excludes or limits liability where such
          exclusion or limitation is prohibited under Indian law.
        </p>

        <h2>37. INDEMNIFICATION</h2>
        <p>
          To the extent permitted by applicable law, you agree to indemnify the
          Company against third-party claims, liabilities, damages and
          reasonable costs arising from:
        </p>
        <ul>
          <li>your unlawful User Content;</li>
          <li>infringement of third-party intellectual-property rights;</li>
          <li>material violation of these Terms; or</li>
          <li>unlawful use of the Platform,</li>
        </ul>
        <p>
          except to the extent attributable to the Company's own acts or
          omissions.
        </p>

        <h2>38. CHANGES TO THESE TERMS</h2>
        <p>The Company may amend these Terms to reflect changes in:</p>
        <ul>
          <li>law or regulation;</li>
          <li>Platform functionality;</li>
          <li>security requirements;</li>
          <li>business operations; or</li>
          <li>legal or regulatory guidance.</li>
        </ul>
        <p>
          Material changes will be communicated through appropriate means where
          required by law.
        </p>
        <p>
          Continued use after an amendment takes effect constitutes acceptance
          only to the extent permitted by applicable law.
        </p>
        <p>
          Where fresh consent is legally required, it will be separately
          obtained.
        </p>

        <h2>39. GOVERNING LAW</h2>
        <p>These Terms are governed by the laws of India.</p>
        <p>
          Subject to applicable consumer-protection law and other mandatory
          jurisdictional requirements, courts at Bangalore, Karnataka, India
          will have exclusive jurisdiction over disputes arising from these
          Terms excluding all other courts in the World.
        </p>

        <h2>40. SEVERABILITY</h2>
        <p>
          If any provision of these Terms is held invalid or unenforceable, the
          remaining provisions will continue in effect to the extent legally
          permissible.
        </p>

        <h2>41. NO WAIVER</h2>
        <p>
          Failure by the Company to enforce a provision on one occasion does not
          constitute a permanent waiver of that provision or any other right.
        </p>

        <h2>42.ENTIRE AGREEMENT</h2>
        <p>
          These Terms, together with the Privacy Policy, Community Guidelines,
          Copyright Policy, Cookie Policy, Creator Terms, Advertising Terms and
          other policies expressly incorporated by reference, constitute the
          agreement governing use of the Platform.
        </p>

        <h2>43. CONTACT DETAILS</h2>

        <p>For general queries:</p>
        <p>
          Email:{" "}
          <a href="mailto:namaste@boloindia.com">namaste@boloindia.com</a>
          <br />
          Website:{" "}
          <a href="https://www.boloindia.com" target="_blank">
            www.boloindia.com
          </a>
        </p>

        <p>For grievances:</p>
        <p>
          <strong>Grievance Officer:</strong> <br />
          Email:
          <a href="mailto:grievances@boloindia.com">grievances@boloindia.com</a>
        </p>

        <p>For privacy and DPDP-related matters:</p>
        <p>
          <strong>
            Privacy Contact / Data Protection Officer, where applicable:
            Email:{" "}
          </strong>{" "}
          <br />
          Email:
          <a href="mailto:grievances@boloindia.com">grievances@boloindia.com</a>
        </p>

        <p>For copyright complaints:</p>
        <p>
          <strong>Copyright Officer:</strong>
          <br />
          Email:{" "}
          <a href="mailto:grievances@boloindia.com">grievances@boloindia.com</a>
        </p>
      </div>

      <LegalLinks />
    </div>
  );
};

export default Terms_of_Services;
